/* eslint-disable */
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Grid,
  IconButton,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import { useEffect, useState } from "react";
import { isNumeric } from "../../../project/utils/utils";
//
// ###########################################################################
//
const EntregaArticuloDialog = ({ articuloAEntregar, setArticuloAEntregar, onSave, onClose, setMessage, setShowMessage }) => {
  const [articuloAEntregarLocal, setArticuloAEntregarLocal] = useState({});
  const [isDoingSomething, setIsDoingSomething] = useState(false);

  //
  // ################################################################################
  //
  useEffect(() => {
    let _articuloAEntregar = { ...articuloAEntregar };

    _articuloAEntregar.cantidadEntregada = _articuloAEntregar.cantidadEntregada === 0 ? _articuloAEntregar.cantidadPendienteEntrega : _articuloAEntregar.cantidadEntregada;

    setArticuloAEntregarLocal(_articuloAEntregar);
  }, []);
  //
  // ################################################################################
  //
  const handleCloseDialog = () => {
    onClose();
  };
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setArticuloAEntregarLocal({
      ...articuloAEntregarLocal,
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleSave = () => {

    if (typeof articuloAEntregarLocal.cantidadEntregada === "string") {
      if (!isNumeric(articuloAEntregarLocal.cantidadEntregada)) {
        setMessage({
          severity: "error",
          messageText: "Debes ingresar una cantidad mayor a 0 y menor o igual a la cantidad pendiente de entrega",
        });
        setShowMessage(true);
        return;
      }
    }

    if (+articuloAEntregarLocal.cantidadEntregada <= 0) {
      setMessage({
        severity: "error",
        messageText: "Debes ingresar una cantidad mayor a 0 y menor o igual a la cantidad pendiente de entrega",
      });
      setShowMessage(true);
      return;
    }

    if (+articuloAEntregarLocal.cantidadEntregada > +articuloAEntregarLocal.cantidadPendienteEntrega) {
      setMessage({
        messageText:
          "La cantidad entregada no puede ser mayor a la cantidad pendiente de entrega.",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    const _articuloAEntregar = {
      ...articuloAEntregarLocal,
      cantidadEntregada: Number(articuloAEntregarLocal.cantidadEntregada),
      cantidadRestante: Number(articuloAEntregarLocal.cantidadPendienteEntrega) - Number(articuloAEntregarLocal.cantidadEntregada),
    };
    setArticuloAEntregar(_articuloAEntregar);
    onSave();
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Dialog
        open={true}
        onClose={(event, reason) => {
          handleCloseDialog();
        }}
        disableEscapeKeyDown={false}
        maxWidth="md"
        fullWidth={true}
        scroll="body"
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title" sx={{ textAlign: "left" }}>
          Artículo a entregar
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Grid container spacing={1}>

            <Grid item xs={12}>
              {articuloAEntregarLocal.codigo} - {articuloAEntregarLocal.descripcion}
            </Grid>

            <Grid item xs={4}>
              <TextField
                sx={{ width: "100%" }}
                id="cantidadVendida"
                label="Vendido"
                variant="outlined"
                size="small"
                name="cantidadVendida"
                value={articuloAEntregarLocal.cantidadVendida}
                disabled={true}
              />
            </Grid>

            <Grid item xs={4}>
              <TextField
                sx={{ width: "100%" }}
                id="cantidadPendienteEntrega"
                label="Para entregar"
                variant="outlined"
                size="small"
                name="cantidadPendienteEntrega"
                value={articuloAEntregarLocal.cantidadPendienteEntrega}
                disabled={true}
              />
            </Grid>

            <Grid item xs={4}>
              <TextField
                sx={{ width: "100%" }}
                id="cantidadEntregada"
                label="Entregado"
                variant="outlined"
                size="small"
                name="cantidadEntregada"
                value={articuloAEntregarLocal.cantidadEntregada}
                onChange={handleChange}
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button
            sx={{ backgroundColor: "warning" }}
            className={"btn-add-dialog"}
            variant="contained"
            size="small"
            onClick={handleSave}
            color="primary"
            startIcon={<SaveIcon />}
            disabled={isDoingSomething}
          >
            Aceptar
          </Button>
          <Button
            variant="outlined"
            className="btn-cancel-dialog"
            size="small"
            onClick={handleCloseDialog}
          >
            Cancelar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default EntregaArticuloDialog;
